import React, { useEffect, useState } from "react";
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '_services';
// reactstrap components
import {
    Button,
    NavItem,
    NavLink,
    Nav,
    Card,
    CardHeader,
    CardBody,
    TabContent,
    TabPane,
    Container,
    Row,
    Col,
} from "reactstrap";

import TSList from "components/Forms/TSList.js";
import TSBooking from "components/Forms/TSBooking.js";
// core components
import TSNavbar from "components/Navbars/TSNavbar.js";
import TrangskinPageHeader2 from "components/Headers/TrangskinPageHeader2.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";

function Home() {
    const [iconTabs, setIconTabs] = React.useState("1");
    const [pills, setPills] = useState("2");
    const [teleItem, setTeleItem] = useState(null);
    useEffect(() => {
        document.body.classList.add("profile-page");
        document.body.classList.add("sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        return function cleanup() {
            document.body.classList.remove("profile-page");
            document.body.classList.remove("sidebar-collapse");
        };
    });
    const currentUser = authenticationService.currentUserValue;
    //console.log(currentUser);
    //check login
    if (!currentUser) {
        // not logged in so redirect to login page with the return url
        return <Redirect to={{ pathname: '/login', /*state: { from: props.location }*/ }} />
    }

    return (
        <>
            <TSNavbar />
            <div className="wrapper">
                <TrangskinPageHeader2 />
                <div className="section">
                    <Container>
                        
                            <Card>
                                <CardHeader>
                                    <Nav className="justify-content-center" role="tablist" tabs>
                                        <NavItem>
                                                    <NavLink
                                                        className={iconTabs === "1" ? "active" : ""}
                                                        href="#pablo"
                                                        onClick={e => {
                                                            e.preventDefault();
                                                            setIconTabs("1");
                                                        }}
                                                    >
                                                        <i className="now-ui-icons objects_umbrella-13"></i>
                                                        รายการนัด
                                                    </NavLink>
                                                </NavItem>    
                                        <NavItem>
                                                    <NavLink
                                                        className={iconTabs === "2" ? "active" : ""}
                                                        href="#pablo"
                                                        onClick={e => {
                                                            e.preventDefault();
                                                            setIconTabs("2");
                                                        }}
                                                    >
                                                        <i className="now-ui-icons shopping_cart-simple"></i>
                                                        รายการพบแพทย์ทางไกล
                                                    </NavLink>
                                                </NavItem>
                                    </Nav>
                                </CardHeader>
                            <CardBody style={{padding:'1px'}}>
                                    <TabContent
                                        className="text-left"
                                        activeTab={"iconTabs" + iconTabs}
                                    >
                                        <TabPane tabId="iconTabs1">
                                            <h4 style={{ marginTop: 0 }} className="title">รายการนัดหมายเข้ารับบริการ</h4>
                                            <TSBooking />

                                            <div className="text-center">
                                                <Button className="btn-round" color="info" size="xs" onClick={() => window.location.href = '/booking'}>
                                                     <i className="fa fa-2x fa-user-md"></i>
                                                    <span style={{ marginLeft: '10px', fontSize: '1.5em' }}>นัดหมายมาโรงพยาบาล</span>
                                                </Button>
                                            </div>
                                        </TabPane>
                                        <TabPane tabId="iconTabs2">
                                            <h4 style={{ marginTop: 0}} className="title">รายการปรึกษาและรับยาทางไกล</h4>
                                            <TSList />
                                     
                                            <div className="text-center">
                                                <Button className="btn-round" color="info" size="xs" onClick={() => window.location.href = '/tele'}>
                                                    <i className="fas fa-video"></i>&nbsp;
                                                        <i className="fa fa-2x fa-user-md"></i>
                                                    <span style={{ marginLeft: '10px', fontSize: '1.5em' }}>นัดหมายพบแพทย์ทางไกล</span>
                                                </Button>
                                            </div>
                              
                                        </TabPane>
                                    </TabContent>
                                </CardBody>
                            </Card>
                            
                            
                   
                        
                       
                    </Container>
                </div>
                <DefaultFooter />
            </div>
        </>
    );
}

export default Home;
